// extracted by mini-css-extract-plugin
module.exports = {"main__wrapper":"style_main__wrapper__3R0Nf","empty":"style_empty__Tzy9A"};